// extracted by mini-css-extract-plugin
export default {"wrapper":"processing_wrapper__nikrQ","btn":"processing_btn__UcrCg","loader":"processing_loader__mcUdn","rotate":"processing_rotate__ZDXLO","text":"processing_text__MFSAZ"};